import { getAllForms } from "@/api/form";
import { useQuery } from "@tanstack/react-query";
import { useSearchParams } from "react-router-dom";

type UseFormsOptions = {
  page?: number;
  size?: number;
  search?: string;
  enabled?: boolean;
};

export const useForms = ({
  page,
  size,
  search,
  enabled = true
}: UseFormsOptions = {}) => {
  const [searchParams] = useSearchParams();

  const pageValue = page ?? (Number(searchParams.get("page")) || 1);
  const sizeValue = size ?? (Number(searchParams.get("size")) || 10);
  const searchValue = search ?? (searchParams.get("search") || "");

  return useQuery({
    queryFn: () => getAllForms({ page: pageValue, size: sizeValue, search: searchValue }),
    queryKey: ["forms", { page: pageValue, size: sizeValue, search: searchValue }],
    refetchOnMount: true,
    enabled
  });
};
